var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="CDB-Overlay">\n  <button type="button" class="CDB-Attribution-button js-button">?</button>\n  <p class="CDB-Attribution-text js-text u-ellipsis">' +
((__t = ( attributions )) == null ? '' : __t) +
'</p>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/geo/ui/attribution/attribution-template.tpl
// module id = 2049
// module chunks = 6